module.exports = __webpack_public_path__ + "img/apple_not_available.ab64b631.jpg";